import { useQuery } from '@tanstack/react-query';

import { getAdminById } from '../../services/adminService';

const useGetAdminById = (
    id?: string,
    userType: string = 'admin',
    enabled: boolean = true
) => {
    const { data, error, isFetching, isLoading, status, isError, refetch } =
        useQuery({
            queryKey: ['get-admins', id],
            queryFn: () => getAdminById(id!),
            refetchOnWindowFocus: true,
            enabled: !!id && userType === 'admin' && enabled,
        });

    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
        status,
        refetch,
    };
};

export default useGetAdminById;
